import request from '@/utils/request'

const baseExamRecordUrl = '/exam/examMistakeNotebook/'

/**
 * 获取练习记录的函数
 * @param {Object} query - 查询参数对象，用于请求练习记录时的过滤条件
 * @returns {Promise} 返回一个Promise对象，包含请求的结果
 */
export function practicing (query) {
  return request({
    url: baseExamRecordUrl + 'practicing', // 请求的URL地址，基础URL加上'practicing'路径
    method: 'get', // 请求方法为GET
    params: query // 请求参数，传入的query对象
  })
}

/**
 * 提交考试答案的函数
 * @param {Object} obj - 包含考试答案数据的对象
 * @returns {Promise} - 返回一个Promise对象，包含服务器响应结果
 */
export function answerQuestions (obj) {
  // 使用request方法发送PUT请求到指定URL
  return request({
    url: baseExamRecordUrl + 'answerQuestions', // 请求的完整URL
    method: 'put', // HTTP请求方法为PUT
    data: obj // 要发送的数据对象
  })
}

